import { render } from "./AddApplicantModal.vue?vue&type=template&id=d6fa1bb4"
import script from "./AddApplicantModal.vue?vue&type=script&lang=js"
export * from "./AddApplicantModal.vue?vue&type=script&lang=js"

import "./AddApplicantModal.vue?vue&type=style&index=0&id=d6fa1bb4&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__